import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useDialogStore = defineStore('dialog', () => {
  const dialoguesOpened = ref(0)

  const isDialogOpen = computed(() => {
    return dialoguesOpened.value > 0
  })

  const dialogCreated = () => {
    dialoguesOpened.value++
    document?.body.classList.add('bx-js-dialog-opened')
  }

  const dialogDestroyed = () => {
    dialoguesOpened.value--
    if (dialoguesOpened.value === 0) {
      document?.body.classList.remove('bx-js-dialog-opened')
    }
  }

  return {
    isDialogOpen,
    dialogCreated,
    dialogDestroyed
  }
})
